export function sqliteCellValue (row: unknown): string | undefined {
  if (typeof row === 'string') {
    return row
  }
  if (row && typeof row === 'object' && 'value' in row) {
    const value = (row as { value: unknown }).value
    return typeof value === 'string' ? value : undefined
  }
  return undefined
}
